import { CookieWriterElementsProcessor } from "./cookie-writer-elements-processor";
import { ICookieWriterOptions } from "../../types/gdpr/cookie-writer-options";

export class CookieWriterElementsProcessorFactory {

    public static createIfNecessary(doc: Document, root?: HTMLElement): CookieWriterElementsProcessor | null {
        const optionsValue = doc.documentElement.getAttribute("data-cookie-writer-options");
        const disableCookieWriters = doc.documentElement.getAttribute("data-disable-cookie-writers") as unknown as boolean;

        if (!optionsValue || !disableCookieWriters) {
            return null;
        }

        const options = JSON.parse(optionsValue) as ICookieWriterOptions;
        return new CookieWriterElementsProcessor(options, root);
    }

}
